/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";

export type AccordionProps = Omit<AccordionPrimitive.AccordionMultipleProps, "type">;

export const Accordion = forwardRef<any, AccordionProps>(({ ...props }, forwardedRef) => (
	<AccordionPrimitive.Root {...props} ref={forwardedRef} type="multiple" />
));

Accordion.displayName = "Accordion.Root";
